import * as React from "react";
import GotoBanks from "../../routing/components/redirects/GotoBanks";
import AccountRoute from "../../accounts/components/pages/AccountRoute";

const BankAccountRoute: React.FC = () => <AccountRoute accountType="bank" errorComponent={GotoBanks} />;

export default BankAccountRoute;
